import $ from 'jquery';

let fieldsAreInitialized = false;

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent =
        wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
    });
  }
}

$(document).on('gform_post_render', function () {
  fieldsAreInitialized = true;
  changeFileUpload();
});

//add aria label on newsletter form submit button + reduce tabindex
document.addEventListener('DOMContentLoaded', () => {
  const newsLetterForm = document.querySelector(
    '.newsletters-required-field_wrapper'
  );

  if (newsLetterForm) {
    const newsletterSubmitButton = newsLetterForm.querySelector(
      'button[type="submit"]'
    );
    const newsletterInput = newsLetterForm.querySelector('input[type="email"]');

    newsletterSubmitButton.setAttribute(
      'aria-label',
      newsletterSubmitButton.innerHTML
    );
    newsletterSubmitButton.setAttribute('tabindex', '0');

    newsletterInput.setAttribute('tabindex', '0');
  }
});

//add tabindex on programs filters input
document.addEventListener('DOMContentLoaded', () => {
  const programsFilters = document.querySelector('.program-filters');

  if (programsFilters) {
    const programsFiltersInput = programsFilters.querySelectorAll('input');

    programsFiltersInput.forEach((input) => {
      const filterPlaceholder = input.getAttribute('placeholder');
      input.setAttribute('tabindex', '0');
      input.setAttribute('aria-label', filterPlaceholder);
    });
  }
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
  }
});
